import type { DRDrawing } from "@/types";
import { ref, watch, type Ref } from "vue";

// scroll to drawing after action on it if it disappears from screen depending on filters / sorting
export const useFocusOnDrawing = (drawings: Ref<DRDrawing[]>) => {
  const focusDrawingId = ref<number | null>(null);

  const scrollToDrawing = (id: number) => {
    const drawingElement = document.querySelector(`[data-drawing-id="${id}"]`);
    if (drawingElement) {
      setTimeout(() => {
        drawingElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    }
  };

  const keepFocusOn = (drawingId: number) => {
    focusDrawingId.value = drawingId;
  };

  watch(
    () => drawings.value,
    () => {
      if (focusDrawingId.value) {
        scrollToDrawing(focusDrawingId.value);
        focusDrawingId.value = null;
      }
    }
  );

  return {
    keepFocusOn,
  };
};
